import {
    BlockExercise,
    PlaylistExercise,
    WorkoutAudioMapType,
    WorkoutBlocksType,
    WorkoutCompleteParamsType,
    WorkoutParamsType,
    WorkoutPlanType,
    WorkoutType,
} from 'types/workouts';

import * as actionTypes from './actionTypes';

export const createWorkout = ({
    params,
    onSuccess,
    onError,
    returnTo,
    planHash,
}: {
    planHash: string | null;
    params: WorkoutParamsType;
    onSuccess: () => void;
    onError: () => void;
    returnTo?: string;
}) => {
    return {
        type: actionTypes.CREATE_WORKOUT,
        payload: {
            params,
            onSuccess,
            onError,
            returnTo,
            planHash,
        },
    } as const;
};

export const setWorkout = (payload: {
    workout: WorkoutType;
    blocks: WorkoutBlocksType;
    playlist: BlockExercise[];
    exercises: PlaylistExercise[];
    name?: string;
}) => {
    return {
        type: actionTypes.SET_WORKOUT,
        payload,
    } as const;
};

export const getWorkoutAudios = () => {
    return {
        type: actionTypes.GET_WORKOUT_AUDIOS,
    } as const;
};

export const setWorkoutAudios = (audiosMap: WorkoutAudioMapType) => {
    return {
        type: actionTypes.SET_WORKOUT_AUDIOS,
        payload: audiosMap,
    } as const;
};

export const workoutComplete = (payload: {
    params: WorkoutCompleteParamsType;
    onSuccess: () => void;
    onError: () => void;
}) => {
    return {
        type: actionTypes.COMPLETE_WORKOUT,
        payload,
    } as const;
};

export const setLoadingState = (payload: boolean) => {
    return {
        type: actionTypes.SET_LOADING_STATE,
        payload,
    } as const;
};

export const getWorkoutPlan = (date: string) => {
    return {
        type: actionTypes.GET_WORKOUT_PLAN,
        payload: { date },
    } as const;
};

export const setWorkoutPlan = (payload: WorkoutPlanType[]) => {
    return {
        type: actionTypes.SET_WORKOUT_PLAN,
        payload,
    } as const;
};

export const getWorkoutById = ({
    id,
    returnTo,
    planHash,
    name,
}: {
    id: number;
    returnTo?: string;
    planHash: string | null;
    name?: string;
}) => {
    return {
        type: actionTypes.GET_WORKOUT_BY_ID,
        payload: { id, returnTo, planHash, name },
    } as const;
};
